import React, { PureComponent } from 'react';
import {
  Card, Col, Nav, NavItem, NavLink, TabContent, TabPane,
} from 'reactstrap';
import {  reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ProfileTimeLine from './ProfileTimeLine';
import ProfileActivities from './ProfileActivities';
import ProfileSettings from './ProfileSettings';

export class ProfileTabs extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: '1',
      user: {},
      histories: []
    };
  }

  handleSubmit(){
  }

  toggle(tab) {
    const { activeTab } = this.state;
    if (activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.user !== this.props.user){
      this.setState({ user: this.props.user});
    }
    if(prevProps.histories !== this.props.histories){
      this.setState({ histories: this.props.histories});
    }
  }

  render() {
    const { t } = this.props;
    const { activeTab, user, histories } = this.state;

    return (
      <Col md={12} lg={12} xl={6}>
        <Card>
          <div className="profile__card tabs tabs--bordered-bottom">
            <div className="tabs__wrap">
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => {
                      this.toggle('1');
                    }}
                  >
                    {t('forms.profile_form_edit.history')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => {
                      this.toggle('2');
                    }}
                  >
                    {t('forms.profile_form_edit.timeLine')}
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '3' })}
                    onClick={() => {
                      this.toggle('3');
                    }}
                  >
                    {t('forms.profile_form_edit.settings')}
                  </NavLink>
                </NavItem>
              </Nav>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="1">
                  <ProfileActivities histories={histories} />
                </TabPane>
                <TabPane tabId="2">
                  <ProfileTimeLine histories={histories} />
                </TabPane>
                <TabPane tabId="3">
                  <ProfileSettings 
                    onSubmit={this.handleSubmit} 
                    user={user} />
                </TabPane>
              </TabContent>
            </div>
          </div>
        </Card>
      </Col>
    );
  }
}

export default reduxForm({
  form: 'profile_tabs_form',
})(withTranslation('common')(ProfileTabs));